import { useEffect } from 'react';
import { useFormikContext } from 'formik';

export const FormObserver: React.FC<{
  onChange: (values: any) => void;
}> = ({ onChange }) => {
  const { values } = useFormikContext();

  useEffect(() => {
    onChange(values);
  }, [values, onChange]);

  return null;
};
